import React, { useCallback, useEffect, useMemo, useState } from "react";
import { notification } from "antd";
import {
  Container,
  Title,
  Card,
  Subtitle,
  StyledInput,
  SearchButton,
  SearchContainer,
  ResultContainer,
  StartServiceButton,
  NumberCircle,
  CodeText,
  ResultCard,
  ResultContent,
  ResultCardContainer,
  CredentialIconWrapper,
  InfoContainer,
  InfosClient,
  CredentialInfo,
  DividerStyled,
  BoothText,
  BoothContainer,
  BoothTitle,
  ErrorSubtitle,
  AccountTypeBadgeStyled,
  ContractText,
  ContractsTextWithPreviewCountsTotals,
  ButtonSearchCredentials,
} from "./styles";
import { ACCOUNT_TYPE_STYLES } from "../../../constants/accountTypes";
import api from "../../../service";
import { useSelector } from "react-redux";
import { useIntl } from "react-intl";
import { useHistory } from "react-router-dom";
import { timerManager } from "../../../utils/timerManager";
import GoBackButton from "../components/goBackButton";
import CredentialStatsDrawer from "../components/CredentialStatsDrawer";
import { ContractNumberBadge } from "../components/badges";
import { SearchIcon2 } from "../components/Icons/search-icon";
import ArrowRightIcon from "../components/Icons/arrow-right";
import { Empty } from "../Services/Sales/components/Empty";
import { HiDocumentCheck } from "react-icons/hi2";
import { IoDocumentText } from "react-icons/io5";
import { PiWarningCircleFill } from "react-icons/pi";
import { FaCheckCircle, FaWarehouse } from "react-icons/fa";

const MAX_BOOTHS_DISPLAY = 8;

// Quantidade de grupos renderizados por vez (renderizacao incremental no scroll).
const PAGE_SIZE = 30;

const StaffSelectClient = () => {
  const intl = useIntl();
  const [searchValue, setSearchValue] = useState("");
  const [clients, setClients] = useState([]);
  const [isSearched, setIsSearched] = useState(false);
  const { token } = useSelector((state) => state.auth);
  const history = useHistory();
  const serviceEventId = localStorage.getItem("serviceEventId");
  const serviceEventName = localStorage.getItem("serviceEventName");
  const eventName = serviceEventName.replace(/-/g, " ");
  const [loading, setLoading] = useState(false);
  const [isDocumentSearch, setIsDocumentSearch] = useState(false);
  const [searchError, setSearchError] = useState(false);
  const MIN_SEARCH_LENGTH = 2;
  const [isCredentialStatsDrawerOpen, setIsCredentialStatsDrawerOpen] =
    useState(false);
  const [credentialStats, setCredentialStats] = useState(null);
  const [selectedContractIndex, setSelectedContractIndex] = useState(null);
  const [loadingCredentialStats, setLoadingCredentialStats] = useState(false);

  useEffect(() => {
    const keysToRemove = [
      "selectedCampanhaId",
      "selectedProfileId",
      "serviceContractNumber",
      "serviceFantasyname",
      "serviceOpportunityId",
      "serviceSystemUserId",
      "serviceRoleType",
      "usuarioId",
      "serviceId",
    ];

    keysToRemove.forEach((key) => {
      localStorage.removeItem(key);
    });
  }, []);

  const handleSearch = async () => {
    if (!searchValue.trim()) return;

    if (searchValue.trim().length < MIN_SEARCH_LENGTH) {
      setSearchError(true);
      return;
    }
    setSearchError(false);

    setClients([]);

    try {
      setLoading(true);
      setIsSearched(true);
      const response = await api.get(
        `/staff/search-clients?eventId=${encodeURIComponent(
          serviceEventId,
        )}&searchTerm=${encodeURIComponent(searchValue.trim())}`,
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "*/*",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const data = response.data;
      setClients(data.opportunities);
      setIsDocumentSearch(data.documentSearch);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setClients([]);
      console.error("Erro ao buscar clientes:", error);
    }
  };

  const formatCpf = (val) => {
    return val
      .replace(/^(\d{3})(\d)/, "$1.$2")
      .replace(/^(\d{3})\.(\d{3})(\d)/, "$1.$2.$3")
      .replace(/^(\d{3})\.(\d{3})\.(\d{3})(\d)/, "$1.$2.$3-$4");
  };

  const formatCnpj = (val) => {
    return val
      .replace(/^(\d{2})(\d)/, "$1.$2")
      .replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
      .replace(/^(\d{2})\.(\d{3})\.(\d{3})(\d)/, "$1.$2.$3/$4")
      .replace(/^(\d{2})\.(\d{3})\.(\d{3})\/(\d{4})(\d)/, "$1.$2.$3/$4-$5");
  };

  const handleChange = (e) => {
    const input = e.target.value;
    const numericInput = input.replace(/\D/g, "");

    let formatted = input;
    const numbersOnly = input.replace(/\D/g, "");

    if (numbersOnly) {
      if (/^\d+$/.test(numericInput)) {
        if (numericInput.length === 11) {
          formatted = formatCpf(numericInput);
        } else if (numericInput.length === 14) {
          formatted = formatCnpj(numericInput);
        } else {
          formatted = input;
        }
      }
    }

    setSearchValue(formatted);
    if (searchError) setSearchError(false);
  };

  const [visibleCount, setVisibleCount] = useState(PAGE_SIZE);

  // Agrupa e deduplica os resultados UMA vez por busca (memoizado), nao a cada
  // render/scroll. Antes o reduce rodava a cada render e o filterContractUserId
  // era O(m^2) por grupo.
  const groupedClients = useMemo(() => {
    const acc = {};

    clients.forEach((client) => {
      // Label exibido ao usuario (sem o tipo de conta).
      const label = `${client.socialreason} / ${client.fantasyname} (${
        client.document.length >= 14
          ? `CNPJ: ${client.document
              .replace(/\D/g, "")
              .replace(
                /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/,
                "$1.$2.$3/$4-$5",
              )}`
          : `${intl.formatMessage({ id: "passport" })}: ${client.document}`
      })`;

      // Um mesmo CNPJ pode ter contratos de tipos diferentes (ex.: Expositor +
      // Patrocinador), entao accountType entra na chave para nao misturar
      // tipos distintos sob um unico grupo/badge.
      const key = `${label}__${client.accountType}`;

      if (!acc[key]) {
        acc[key] = {
          label,
          fantasyname: client.fantasyname,
          accountType: client.accountType,
          contracts: [],
        };
      }

      acc[key].contracts.push({
        contractNumber: client.contractNumber,
        opportunityId: client.opportunityId,
        systemUserId: client.systemUserId,
        booths: client.booths || [],
        hasCredential: client.hasCredential || false,
        roleType: client.roleType,
      });
    });

    return Object.entries(acc)
      .map(([key, { label, fantasyname, accountType, contracts }]) => ({
        key,
        label,
        fantasyname,
        accountType,
        contracts: dedupeByContractNumber(contracts),
      }))
      .sort((a, b) => {
        const labelCompare = a.label.localeCompare(b.label);
        if (labelCompare !== 0) return labelCompare;
        return (a.accountType || "").localeCompare(b.accountType || "");
      });
  }, [clients, intl]);

  // Mesma lista/ordem exibida na busca (groupedClients), apenas achatada para
  // navegar entre contratos no drawer de credenciais via previous/next.
  const flattenedContracts = useMemo(
    () =>
      groupedClients.flatMap(({ fantasyname, contracts }) =>
        contracts.map((contract) => ({ ...contract, fantasyname })),
      ),
    [groupedClients],
  );

  const selectedContract =
    selectedContractIndex != null
      ? flattenedContracts[selectedContractIndex]
      : null;
  const hasPreviousContract = (selectedContractIndex ?? 0) > 0;
  const hasNextContract =
    selectedContractIndex != null &&
    selectedContractIndex < flattenedContracts.length - 1;

  const fetchCredentialStats = useCallback(
    async ({ opportunityId, systemUserId }) => {
      setCredentialStats(null);
      setLoadingCredentialStats(true);

      try {
        const response = await api.get(
          `/accreditation/history?opportunityId=${opportunityId}&userId=${systemUserId}`,
          {
            headers: {
              "Content-Type": "application/json",
              Accept: "*/*",
              Authorization: `Bearer ${token}`,
            },
          },
        );

        setCredentialStats(response.data?.credentialSumQuotaOutput || {});
      } catch (error) {
        notification.error({
          message: intl.formatMessage({ id: "error" }),
          description: intl.formatMessage({ id: "credentialsError" }),
        });
        setIsCredentialStatsDrawerOpen(false);
      } finally {
        setLoadingCredentialStats(false);
      }
    },
    [intl, token],
  );

  // Localiza o contrato clicado pelo opportunityId (identificador unico do contrato)
  // para abrir o drawer ja na posicao correta de navegacao.
  const handleCheckCredentials = useCallback(
    (opportunityId) => {
      const index = flattenedContracts.findIndex(
        (contract) => contract.opportunityId === opportunityId,
      );
      if (index === -1) return;

      setSelectedContractIndex(index);
      setIsCredentialStatsDrawerOpen(true);
    },
    [flattenedContracts],
  );

  // Busca os totalizadores sempre que o contrato selecionado mudar (abertura
  // inicial ou navegacao pelo previous/next do drawer).
  useEffect(() => {
    if (!isCredentialStatsDrawerOpen || selectedContractIndex == null) return;

    const contract = flattenedContracts[selectedContractIndex];
    if (!contract) return;

    fetchCredentialStats(contract);
  }, [
    isCredentialStatsDrawerOpen,
    selectedContractIndex,
    flattenedContracts,
    fetchCredentialStats,
  ]);

  const handlePreviousContract = useCallback(() => {
    setSelectedContractIndex((current) =>
      current > 0 ? current - 1 : current,
    );
  }, []);

  const handleNextContract = useCallback(() => {
    setSelectedContractIndex((current) =>
      current < flattenedContracts.length - 1 ? current + 1 : current,
    );
  }, [flattenedContracts.length]);

  const handleStartService = useCallback(
    ({
      opportunityId,
      fantasyname,
      contractNumber,
      systemUserId,
      roleType
    }) => {
      localStorage.setItem("serviceOpportunityId", opportunityId);
      localStorage.setItem("serviceFantasyname", fantasyname);
      localStorage.setItem("serviceContractNumber", contractNumber);
      localStorage.setItem("serviceSystemUserId", systemUserId);
      localStorage.setItem("serviceRoleType", roleType || "");
      timerManager.reset();
      history.push("/staff-access/service-panel");
    },
    [history],
  );

  // Reinicia a janela de renderizacao a cada nova busca.
  useEffect(() => {
    setVisibleCount(PAGE_SIZE);
  }, [clients]);

  // Renderizacao incremental: a busca nao e paginada no backend (todos os resultados
  // chegam de uma vez), entao montamos apenas PAGE_SIZE grupos por vez e carregamos
  // mais conforme o usuario rola. O scroll ocorre DENTRO do ResultContent (altura fixa
  // de 400px, overflow-y: auto), por isso ouvimos o onScroll do proprio container.
  const handleResultsScroll = (event) => {
    const el = event.currentTarget;
    const reachedNearBottom =
      el.scrollTop + el.clientHeight >= el.scrollHeight - 300;
    if (reachedNearBottom) {
      setVisibleCount((current) =>
        Math.min(current + PAGE_SIZE, groupedClients.length),
      );
    }
  };

  const visibleGroups = groupedClients.slice(0, visibleCount);

  return (
    <>
      <Container>
        <GoBackButton href={"/staff-access/select-event"} noPosition />
        <Card>
          <ContractNumberBadge contractNumber={eventName} event />
          <Title> {intl.formatMessage({ id: "search_client" })}</Title>
          <Subtitle>
            {intl.formatMessage({
              id: "search_client_using_the_business_name_trade_name_cnpj_cpf_or_passport",
            })}
          </Subtitle>
          <SearchContainer>
            <StyledInput
              placeholder={intl.formatMessage({
                id: "enter_the_client_company_name_trade_CNPJ_CPF",
              })}
              value={searchValue}
              onChange={handleChange}
              onPressEnter={handleSearch}
            />
            <SearchButton onClick={handleSearch}>
              <SearchIcon2 />
            </SearchButton>
          </SearchContainer>
          {searchError && (
            <ErrorSubtitle role="alert">
              *{intl.formatMessage({ id: "search_min_characters" })}
            </ErrorSubtitle>
          )}
        </Card>
      </Container>

      {!loading && isSearched && clients.length === 0 && <Empty />}

      {!loading && clients.length > 0 && (
        <ResultContainer>
          <ResultContent onScroll={handleResultsScroll}>
            <Title style={{ marginBottom: "20px" }} results>
              {intl.formatMessage({
                id: clients.length > 1 ? "results:" : "result:",
              })}
            </Title>

            {visibleGroups.map(
              ({ key, label, fantasyname, accountType, contracts }) => {
                const accountTypeStyle = ACCOUNT_TYPE_STYLES[accountType];

                return (
                  <div key={key}>
                    <Subtitle results>
                      {label}{" "}
                      {accountTypeStyle && (
                        <AccountTypeBadgeStyled
                          $color={accountTypeStyle.color}
                          $backgroundColor={accountTypeStyle.backgroundColor}
                        >
                          {intl.formatMessage({ id: accountTypeStyle.intlId })}
                        </AccountTypeBadgeStyled>
                      )}
                    </Subtitle>
                    <ResultCardContainer>
                      {contracts.map(
                        (
                          {
                            contractNumber,
                            opportunityId,
                            systemUserId,
                            booths,
                            hasCredential,
                            roleType,
                          },
                          i,
                        ) => (
                          <ResultCard
                            hasCredential={hasCredential}
                            key={`${key}-${contractNumber}-${i}`}
                            index={i.toString()}
                          >
                            <InfoContainer>
                              <ContractsTextWithPreviewCountsTotals>
                                <InfosClient>
                                  <CredentialIconWrapper
                                    hasCredential={hasCredential}
                                  >
                                    {hasCredential ? (
                                      <HiDocumentCheck />
                                    ) : (
                                      <IoDocumentText />
                                    )}
                                  </CredentialIconWrapper>

                                  <ContractText>
                                    <NumberCircle>{i + 1}</NumberCircle>
                                    <CodeText>{contractNumber}</CodeText>
                                  </ContractText>
                                </InfosClient>

                                <ButtonSearchCredentials
                                  onClick={() =>
                                    handleCheckCredentials(opportunityId)
                                  }
                                >
                                  {intl.formatMessage({
                                    id: "check_credentials",
                                  })}
                                </ButtonSearchCredentials>
                              </ContractsTextWithPreviewCountsTotals>

                              {isDocumentSearch && (
                                <CredentialInfo hasCredential={hasCredential}>
                                  {hasCredential ? (
                                    <FaCheckCircle />
                                  ) : (
                                    <PiWarningCircleFill />
                                  )}

                                  {hasCredential
                                    ? intl.formatMessage({
                                        id: "collaborator.has_credential",
                                      })
                                    : intl.formatMessage({
                                        id: "collaborator.has_no_credential",
                                      })}
                                </CredentialInfo>
                              )}
                            </InfoContainer>

                            {booths.length > 0 && (
                              <>
                                <DividerStyled type="vertical" />
                                <BoothContainer>
                                  <BoothTitle>
                                    <FaWarehouse />
                                    {intl.formatMessage({
                                      id:
                                        booths.length > 1 ? "booths" : "booth",
                                    })}
                                    :
                                  </BoothTitle>
                                  <BoothText>
                                    {booths
                                      .slice(0, MAX_BOOTHS_DISPLAY)
                                      .map((booth, boothIndex, arr) => (
                                        <span key={boothIndex}>
                                          {booth}
                                          {boothIndex < arr.length - 1 && ", "}
                                        </span>
                                      ))}
                                  </BoothText>
                                </BoothContainer>
                              </>
                            )}

                            <StartServiceButton
                              onClick={() =>
                                handleStartService({
                                  opportunityId,
                                  fantasyname,
                                  contractNumber,
                                  systemUserId,
                                  roleType,
                                })
                              }
                            >
                              {intl.formatMessage({ id: "start_service" })}{" "}
                              <ArrowRightIcon />
                            </StartServiceButton>
                          </ResultCard>
                        ),
                      )}
                    </ResultCardContainer>
                  </div>
                );
              },
            )}
          </ResultContent>
        </ResultContainer>
      )}

      <CredentialStatsDrawer
        open={isCredentialStatsDrawerOpen}
        onClose={() => setIsCredentialStatsDrawerOpen(false)}
        fantasyname={selectedContract?.fantasyname}
        contractNumber={selectedContract?.contractNumber}
        credentialStats={credentialStats}
        loading={loadingCredentialStats}
        onPrevious={handlePreviousContract}
        onNext={handleNextContract}
        hasPrevious={hasPreviousContract}
        hasNext={hasNextContract}
        onStartService={() =>
          selectedContract && handleStartService(selectedContract)
        }
      />
    </>
  );
};

export default StaffSelectClient;

// Deduplica por contractNumber em O(m). Antes era O(m^2) (.some aninhado) e vinha
// embrulhado em [...new Set(...)], que nao tinha efeito (objetos sao unicos por referencia).
function dedupeByContractNumber(contracts) {
  const seen = new Set();
  const sanitizedContracts = [];

  contracts.forEach((c) => {
    if (seen.has(c.contractNumber)) return;
    seen.add(c.contractNumber);
    sanitizedContracts.push(c);
  });

  return sanitizedContracts;
}
